import {createApi} from '@reduxjs/toolkit/dist/query/react';
import {baseQuery} from '../../base.api';

export const revisionsApi = createApi({
  reducerPath: 'revisions/api',
  baseQuery: baseQuery(import.meta.env.VITE_API_URL),
  keepUnusedDataFor: 0.0001,
  endpoints: build => ({
    getRevisionOptions: build.query({
      query: params => ({
        url: 'inspection-revisions',
        params,
      }),
    }),
  }),
});

export const {useLazyGetRevisionOptionsQuery} = revisionsApi;
